import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpdateNavbarEvent {
  private logo = new BehaviorSubject(null);
  private colorNavbar = new BehaviorSubject(null);
  private colorNavbarHome = new BehaviorSubject(null);

  updatedLogo = this.logo.asObservable();
  updatedColorNavbar = this.colorNavbar.asObservable();
  updatedColorNavbarHome = this.colorNavbarHome.asObservable();

  updateLogo(status: any) {
    this.logo.next(status);
  }

  updateColorNavbar(status: any) {
    this.colorNavbar.next(status);
  }
  
  updateColorNavbarHome(status: any) {
    this.colorNavbarHome.next(status);
  }

  
}
